import React from 'react';
import AgencyProfile from '@domain-group/fe-pa-allhomes-agency-profile';
import StandardPage from './common/standard-page.js';

/* eslint-disable react/jsx-filename-extension */

export default (props) => <StandardPage component={AgencyProfile} {...props} />;
